import { t } from "@lingui/macro";
import FormComponent from '../../../components/FormComponent';
import parseFormDefinition from '../../../util/parseFormDefinition';


export const RoleDetailsEditor = FormComponent({
    ...parseFormDefinition({
        displayName: 'RoleDetailsEditor',
        title: t`Role Details`,
        schemaProps: {
            "title": [t`Role`, " ${name}"].join(''),
            "ui:newSection": true,
            ":classNames": "grid-2-columns",
        },
        schema: {
            // type: "object",
            "name": {
                "title": t`Name`,
                "map:field": "name",
                "type": "string",
            },
            "flags": {
                ":classNames": "from-col-1-size-1 flex-h",
                "type": "object",
                "title": " ",
                "properties": {
                    "canWorkUnassigned": {
                        "title": t`Can Work Unassigned`,
                        "map:field": "extras.canWorkUnassigned",
                        "type": "boolean",
                    },
                }
            },
        },
    }),
    withoutNavigation: true,
    parseProps: ({ role, onChange }) => ({
        role,
        onRoleChange: onChange
    }),
    loadData: ({ role }) => role,
    hideDataLoader: true,
    onChange({
        formObject,
        parsedProps: {
            onRoleChange
        }
    }) {
        if (!formObject) return;
        onRoleChange(formObject);
    },
    onSubmit: ({ formData }) => Promise.resolve(),
    submitButtons: {}
});

export default RoleDetailsEditor;
